import Toast from "../components/Toast";
import { useToastStateContext } from "../context/toastContext";

function ToastContainer() {
    const { toasts } = useToastStateContext();

    return (
        <div className="toasts-wrapper">
            {toasts.map((toast, index) => (<Toast key={toast.id} {...toast} index={index}>{toast.message}</Toast>))}
      </div>
    )
}

export default ToastContainer;